export default __webpack_public_path__ + "static/media/mobile_reward1_detail_5-1.f3da8c88.png";